<div id="facility-export-loading" class="dashboard-loading-container loader load-{{isDataLoading()}}">
  <div class="ndnqi-spinner">
    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
  </div>
</div>

<div>
    <app-facility-export-options [hospid]="hospid"
        (exportRequested)="onExportRequest($event)" >
    </app-facility-export-options>
</div>

<p></p>
  <ng-container *ngIf="hospid">
    <div>
        <app-facility-export-history [hospid]="hospid"></app-facility-export-history>
    </div>
  
  </ng-container>